import { Tab } from '../types'

import { TabNames } from './settings.enum'

export const TabData: Array<{ name: TabNames; tab: Tab }> = [
  {
    name: TabNames.PROFILE_INFORMATION,
    tab: Tab.PERSONAL_INFO,
  },
  {
    name: TabNames.MY_PROFILE,
    tab: Tab.PROFILE,
  },
  {
    name: TabNames.CHANGE_PASSWORD,
    tab: Tab.CHANGE_PASSWORD,
  },
]

/**
 * School students cannot change their own password, so the tab is dropped from their settings menu.
 * See `useCanChangePassword` for why the rule is role-based rather than platform-based.
 * The profile settings tab is dropped for everyone on the school platform.
 */
export const getVisibleTabData = (canChangePassword: boolean, isSchoolPlatform: boolean): typeof TabData =>
  TabData.filter((elem) => {
    if (elem.tab === Tab.CHANGE_PASSWORD) return canChangePassword
    if (elem.tab === Tab.PROFILE) return !isSchoolPlatform

    return true
  })
